import { render, staticRenderFns } from "./Base.vue?vue&type=template&id=c40ca874&scoped=true&"
import script from "./Base.vue?vue&type=script&lang=js&"
export * from "./Base.vue?vue&type=script&lang=js&"
import style0 from "./Base.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Base.vue?vue&type=style&index=1&id=c40ca874&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40ca874",
  null
  
)

export default component.exports